const { handleAPIValidationError } = require('../../../api/errors');
const { ERROR_MESSAGE } = require('../constants');

/**
 * Checks if a certain brief exists under makers redis
 * @returns {Promise<boolean>}
 */
const exists = (redis) => async(id) => {
    if (!redis) {
        return handleAPIValidationError('exists', ERROR_MESSAGE.REDIS_UNINITIALISED);
    }

    if (!id) {
        return handleAPIValidationError('exists', ERROR_MESSAGE.ID_MISSING);
    }

    try {
        const briefKey = `brief_${id}`;

        return !!await redis.exists(briefKey);
    } catch (e) {
        return false;
    }
};

module.exports = exists;
